/**
 * R$ apenas em leilão / aguardando aprovação de orçamento (não por assinatura).
 */
export function shouldShowBrlForDemand({ status, isAuction } = {}) {
  if (status === 'in_auction') return true
  if (status === 'waiting_approval' || status === 'waiting_estimate_approval') return true
  if (isAuction === true) return true
  return false
}

/** Multiplicador legado (×2 exceto em waiting_estimate_approval) quando em contexto R$. */
export function brlDisplayMultiplier(status) {
  return status !== 'waiting_estimate_approval' ? 2 : 1
}

export function formatDemandUnitPrice(price, demand) {
  if (price === undefined || price === null || price === '') return ''
  const { status, isAuction } = demand || {}
  const showBrl = shouldShowBrlForDemand({ status, isAuction })
  if (!showBrl) return `${price} BNZs`
  const mult = brlDisplayMultiplier(status)
  return `R$ ${Number(price) * mult}`
}

export function formatBidUnitPrice(price, demand, bid) {
  if (price === undefined || price === null || price === '') return ''
  const { status, isAuction } = demand || {}
  const showBrl = shouldShowBrlForDemand({ status, isAuction })
  if (!showBrl) {
    const acquired =
      bid && (bid.isBNZAdquired === true || bid.isBNZAdquired === null) ? ' (Adquirido)' : ''
    return `${price} BNZs${acquired}`
  }
  const mult = brlDisplayMultiplier(status)
  return `R$ ${Number(price) * mult}`
}
